import React from "react";
import { FieldArray } from "react-final-form-arrays";
import { Button, Card, Stack } from "@shopify/polaris";
import styles from "./MultipleConditionsCard.module.css";
import ConditionsCard from "./components/ConditionsCard.js";
import { ATTRIBUTE_TITLE } from "../../../../../../../../../../../constants/attributeTypes.js";
import { ATTRIBUTE_QUALIFIER_EQUAL } from "../../../../../../../../../../../constants/attributeQualifierTypes.js";

const MultipleConditionsCard = ({ }) => {
  return (
    <Card>
      <Card.Section title={
        <div className={styles["card-text"]}>
          <p>
            You can add multiple conditions using AND and OR logic operators below.
          </p>
        </div>
      }>
        <Stack vertical>
          <FieldArray name="multipleConditionsArray">
            {({ fields }) => (
              <Stack vertical>
                {fields.map((multipleCondition, index) => {
                  return (
                    <Stack vertical key={multipleCondition}>
                      <ConditionsCard multipleCondition={multipleCondition} />
                      <Stack distribution={"trailing"} alignment={"center"}>
                        <Button
                          plain
                          removeUnderline
                          onClick={() => fields.remove(index)}
                        >
                          Delete criteria
                        </Button>
                      </Stack>
                      {fields.length !== index + 1 &&
                        <div className={styles["text-between"]}>
                          OR
                        </div>
                      }
                    </Stack>
                  );
                })}
                <Button
                  onClick={() => fields.push({
                    conditions: [{
                      attribute: ATTRIBUTE_TITLE,
                      qualifier: ATTRIBUTE_QUALIFIER_EQUAL,
                      value: ""
                    }]
                  })}
                >
                  OR
                </Button>
              </Stack>
            )}
          </FieldArray>
        </Stack>
      </Card.Section>
    </Card>

  );
};

export default MultipleConditionsCard;